export default __webpack_public_path__ + "static/map-poster-fe83a5158ac66bc66ca37e048590bacf.jpg";